module.exports = __webpack_public_path__ + "poing.png?c80b614982d5554c08309400b745e1fa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/poing.png
// module id = 189
// module chunks = 0